<div class="d-flex justify-content-between align-items-center mb-2">
  <h3 class="mat-title-medium m-0">{{ text() }}</h3>
  <mat-button-toggle-group #group="matButtonToggleGroup" value="grid">
    <mat-button-toggle value="grid" aria-label="Grid view">
      <mat-icon>grid_view</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="compact" aria-label="List view">
      <mat-icon>view_list</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>

<!-- Spot highlights -->
@if(highlightedSpots.length > 0) {
<h4
  class="mat-title-medium"
  i18n="
    Title for the spot highlights, spots is clear from the
    context@@spot_highlights"
>
  Highlights
</h4>
<div [class.compact]="group.value === 'compact'" class="spot-container pb-3">
  @for(spot of highlightedSpots; track $index) { @if(withHrefLink()) {
  <a [routerLink]="['/map', spot.id]">
    <app-spot-preview-card
      [spot]="spot"
      [infoOnly]="true"
      [clickable]="true"
      [isCompact]="group.value === 'compact'"
      class="w-100"
    >
    </app-spot-preview-card>
  </a>
  } @else {
  <app-spot-preview-card
    [spot]="spot"
    [infoOnly]="true"
    [clickable]="true"
    [isCompact]="group.value === 'compact'"
    (click)="spotClick($index)"
    class="w-100"
  >
  </app-spot-preview-card>
  } }
</div>
}

<!-- All spots except highlights -->
@if(remainingSpots.length > 0 && highlightedSpots.length > 0) {
<h4 class="mat-title-medium" i18n="@@regular_spots_text">Spots</h4>
} @if(remainingSpots.length > 0) {
<div [class.compact]="group.value === 'compact'" class="spot-container">
  @for(spot of remainingSpots; track $index) { @if(withHrefLink()) {
  <a [routerLink]="['/map', getSpotId(spot)]">
    <app-spot-preview-card
      [spot]="spot"
      [infoOnly]="true"
      [clickable]="true"
      [isCompact]="group.value === 'compact'"
      [imgSize]="400"
      class="w-100"
    >
    </app-spot-preview-card> </a
  >} @else {
  <app-spot-preview-card
    [spot]="spot"
    [infoOnly]="true"
    [clickable]="true"
    [isCompact]="group.value === 'compact'"
    [imgSize]="400"
    class="w-100"
    (click)="spotClick($index)"
  >
  </app-spot-preview-card>
  } }
</div>
}

<!-- No spots and no highlights text -->
@if(remainingSpots.length === 0 && highlightedSpots.length === 0) {
<div class="d-flex justify-content-center align-items-center h-100">
  <p
    class="mat-body-large"
    i18n="
      The text in the spot list panel if no spots are
      found/displayed@@no_spots_text"
  >
    There are no highlighted spots for this area, zoom in on dots in the map to
    discover other spots.
  </p>
</div>
}
